import React, { useContext } from "react";
import { ViewContext } from "./contexts/ViewContext";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemText from "@mui/material/ListItemText";
import { Avatar, ListItemAvatar } from "@mui/material";
import AccessibleForwardIcon from "@mui/icons-material/AccessibleForward";
import WcIcon from "@mui/icons-material/Wc";
import ListItemSecondaryAction from "@mui/material/ListItemSecondaryAction";
import IconButton from "@mui/material/IconButton";
import PoiIcon from "./PoiIcon";

const COLORS = [
    { value: "yes", color: "#36d3c1" },
    { value: "limited", color: "#ffa55c" },
    { value: "no", color: "#ff477b" },
    { value: "", color: "#bdbdbd" },
];

export default function PoiList({ pois }) {
    const { view, dispatch } = useContext(ViewContext);

    console.log(pois);
    const handleSelect = (poi) => {
        if (view.pageNo === 1)
            dispatch({ type: "SELECT POI", poi: poi, direction: 1 });
    };

    const getAccessibilityColor = (tag) => {
        return COLORS.find((c) => c.value === tag)?.color || "#bdbdbd";
    };

    const poiList = pois.map((p) => (
        <ListItem
            button
            value={p.id}
            onClick={() => handleSelect(p)}
            key={p.id}
        >
            <ListItemAvatar
                style={{ height: "40px", width: "40px", minWidth: "40px" }}
            >
                <Avatar
                    style={{
                        height: "30px",
                        width: "30px",
                        color: "white",
                        backgroundColor: getAccessibilityColor(
                            p.tags.wheelchair
                        ),
                    }}
                >
                    <AccessibleForwardIcon />
                </Avatar>
            </ListItemAvatar>
            <ListItemAvatar style={{ height: "40px", width: "40px" }}>
                <Avatar
                    style={{
                        height: "30px",
                        width: "30px",
                        color: "white",
                        backgroundColor: getAccessibilityColor(
                            p.tags["toilets:wheelchair"]
                        ),
                    }}
                >
                    <WcIcon />
                </Avatar>
            </ListItemAvatar>
            <ListItemText
                primary={
                    p.tags.name ||
                    p.tags.amenity ||
                    p.tags.shop ||
                    p.tags.tourism ||
                    p.tags.leisure ||
                    p.tags.historic ||
                    p.tags.office ||
                    ""
                }
                secondary={`${Math.round(p.distance * 1000)} m`}
            />
            <ListItemSecondaryAction>
                <IconButton edge="end" aria-label="delete">
                    <PoiIcon poi={p} />
                </IconButton>
            </ListItemSecondaryAction>
        </ListItem>
    ));
    return (
        <div>
            {pois.length ? (
                <List component="nav">{poiList}</List>
            ) : view.locale === "hu" ? (
                "Helyek betöltése..."
            ) : (
                view.locale === "en" && "Venues loading..."
            )}
        </div>
    );
}
